import ApiService from "../ApiService";

const OrderEditionService = {

  registerOrderEdition(data) {
    return ApiService.post(`order-edition`, data);
  },

  enableOrderEdition(data) {
    return ApiService.post(`order-edition/enable-order-edition`, data);
  },

  getBlockedOrders(page, perPage) {
    return ApiService.get(`order-edition/blocked-orders?page=${page}&perPage=${perPage}`);
  },

  unBlockOrder(id, data) {
    return ApiService.patch(`order-edition/${id}`, data);
  }
};

export default OrderEditionService;
